<div class="login-system-container">
    <p>Hệ thống đang xác thực người dùng, vui lòng chờ...</p>
</div>
